import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default (state: boolean) =>
  createStyles({
    changeAccountContainer: {
      padding: 15,
      alignItems: 'center',
    },
    changeAccountContainerError: {
      padding: 15,
      alignItems: 'center',
      backgroundColor: palette.backgroundSuperLightRed,
    },
    currentAccount: {
      fontWeight: 'bold',
      fontSize: 14,
      color: palette.navCompanyContextActions,
    },
    newAccount: {
      fontWeight: 'bold',
      fontSize: 14,
      color: palette.green,
    },
    accountName: { fontSize: 16 },
    arrow: {
      width: '10px',
      marginLeft: '50px',
      transform: 'translate(-50%, -50%) rotate(270deg)',

      '& span': {
        display: 'block',
        width: '10px',
        height: '10px',
        borderBottom: `2px solid ${palette.green}`,
        borderRight: `2px solid ${palette.green}`,
        transform: 'rotate(45deg)',
        margin: '-10px',
        animation: '$arrow 2s infinite',
      },

      '& span:nth-child(2)': {
        animationDelay: '-0.2s',
      },
      '& span:nth-child(3)': {
        animationDelay: '-0.4s',
      },
    },
    '@keyframes arrow': {
      '0%': {
        opacity: '0',
        transform: 'rotate(45deg) translate(-20px, -20px)',
      },
      '50%': {
        opacity: '1',
      },
      '100%': {
        opacity: '0',
        transform: 'rotate(45deg) translate(20px, 20px)',
      },
    },
    autocompleteCompany: {
      cursor: 'pointer',
      padding: 12,
      width: '100%',
      border: `1px solid rgba(0, 0, 0, 0.15)`,
      borderRadius: '3px',
      display: 'flex',
      borderColor: palette.borderGray,

      '& .MuiButton-label': { justifyContent: 'flex-start' },
    },
    name: {
      fontSize: 12,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 200,
      minWidth: 200,
      maxWidth: 200,
    },
    likeCell: {
      width: 20,
      padding: 0,
      textAlign: 'right',
      '& .MuiTableCell-root': {
        padding: 0,
      },
    },
    tableRow: {
      height: 20,
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },
    itemSelected: {
      '& .MuiTableCell-root': {
        fontWeight: 600,
        lineHeight: 0,
      },
    },
    companyCell: {
      width: 150,
      minWidth: 150,
      maxWidth: 150,
      cursor: 'pointer',
      padding: '0px 0px 0px 16px',
      '& .MuiTableCell-root': {
        paddingLeft: 0,
      },
    },
    selectHeader: { maxWidth: 50 },
    select: { paddingRight: 5 },
    checkIcon: { color: palette.green, width: 15, height: 15 },
    changeButton: { color: palette.blue, borderColor: palette.blue },
    cancelButton: { color: palette.red, borderColor: palette.red },
    buttons: { margin: '16px 0px 0px 8px' },
    changeAccountSuperAdmin: {
      border: `1px solid ${palette.navSuperAdminActions}`,
      padding: '10px 20px 0px 20px',
      borderRadius: 10,
    },
    changeAccountAdmin: {
      border: `1px solid ${palette.navAdminActions}`,
      padding: '10px 20px 0px 20px',
      borderRadius: 10,
    },
    changeAccountOperator: {
      border: `1px solid ${palette.navOperatorActions}`,
      padding: '10px 20px 0px 20px',
      borderRadius: 10,
    },
    changeAccountContext: {
      border: `1px solid ${palette.navCompanyContextActions}`,
      padding: '10px 20px 0px 20px',
      borderRadius: 10,
    },
    noChangeAccount: { marginTop: 15 },
    buttonBottom: { paddingTop: 16 },
    container: {
      marginTop: 16,
      width: '100%',
      backgroundColor: palette.white,
      color: palette.white,
      overflow: 'hidden',
      boxShadow: '0 2px 4px 0 rgb(0 0 0 / 40%)',
      position: 'relative',
      borderRadius: 8,
    },
    rowAllRows: {
      width: '55%',
      fontSize: 12,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    rowReason: {
      fontSize: 12,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: 150,
    },
    rowDate: {
      width: '15%',
      fontSize: 12,
    },
    rowAllRowsCount: {
      width: '15%',
      fontSize: 12,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      justifyContent: 'center',
    },
    rowAllRowsCountType: {
      maxWidth: 100,
      fontSize: 12,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      justifyContent: 'center',
    },
    rowsCount: {
      width: '0%',
      fontSize: 12,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      justifyContent: 'center',
    },
    loadingContainer: {
      justifyContent: 'center',
      marginTop: 100,
    },
    deleteButton: {
      backgroundColor: palette.error.main,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.error.main,
      },
    },
    deleteButtons: {
      marginTop: 15,
    },
    deleteText: { fontSize: 14, fontWeight: 500 },
    deleteTextGrid: {
      margin: '5px 10px 25px 10x',
      paddingBottom: 15,
    },
    deleteSubtext: { fontSize: '11px', display: 'flex', alignItems: 'center' },
    warningIcon: {
      color: palette.error.main,
      width: 15,
      height: 15,
      marginRight: 5,
    },
    deleteSubtextGrid: { display: 'flex', marginTop: 10 },
    fields: {
      '& .MuiFormControl-fullWidth': { margin: '6px 0px' },
      '& .MuiOutlinedInput-multiline': { display: 'inline-table', padding: 14 },
    },
    errorIcon: { color: palette.red, marginRight: 8 },
    errorText: { color: palette.darkRed },
    errorItemsGrid: { marginLeft: 30 },
    errorTextDescription: { fontSize: 14, color: palette.darkGray },
    errorTitle: { marginBottom: 8 },
    warnTitle: { margin: '8px 0px 4px 30px' },
    warnText: { color: palette.darkerGray, fontWeight: 500 },
    warnButtonGrid: { marginBottom: 4 },
    warnButton: { color: palette.red, borderColor: palette.red },
    closeIcon: {
      cursor: 'pointer',
      padding: 0,
      color: palette.darkGray,
      '& .MuiSvgIcon-root': { width: 15, height: 15 },
    },
    chooseAnotherButton: {
      color: palette.blue,
      borderColor: palette.blue,
      marginRight: 8,
    },
    goConfigButton: {
      color: palette.darkerGray,
      borderColor: palette.darkerGray,
      marginRight: 8,
    },
    defaultIcon: {
      fontSize: 15,
      width: 15,
      height: 15,
      cursor: 'pointer',
      opacity: 0.5,
      backgroundColor: palette.lightNavSuperAdminActions,
      color: palette.navSuperAdmin,
      borderRadius: 5,
    },
    boldText: { fontWeight: 500 },
    spacing: { marginRight: 5 },
    spacingGrid: { margin: '8px 0px' },
    warnToMigrate: {
      color: palette.deepBlue,
      width: 20,
      height: 20,
      marginRight: 4,
    },
    gridWarnToMigrate: {
      display: 'flex',
      alignItems: 'center',
      height: 16,
    },
    gridWarnToMigrateTitle: {
      display: 'flex',
      alignItems: 'center',
      height: 32,
    },
    warnToMigrateText: {
      fontSize: 12,
      display: 'flex',
      alignItems: 'center',
    },
    warnToMigrateTextTitle: {
      fontSize: 14,
      display: 'flex',
      alignItems: 'center',
    },
    cardButtons: {
      justifyContent: 'flex-end',
      display: 'flex',
      alignItems: 'flex-end',
    },
    errorSamePartner: { color: palette.red, fontSize: 11, marginTop: 1 },
    errorSamePartnerButton: { borderColor: palette.red },
    detailsTextTitle: {
      fontSize: 14,
      marginRight: 4,
      color: palette.darkGray,
      fontWeight: 500,
    },
    detailsTextTableType: {
      fontSize: 12,
      width: '100%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    detailsText: { fontSize: 14 },
    detailsTextYes: { fontSize: 12, marginLeft: 4, color: palette.green },
    detailsTextNo: { fontSize: 12, marginLeft: 4, color: palette.red },
    detailsTextTitleYes: { fontSize: 14, color: palette.green },
    detailsTextTitleNo: { fontSize: 14, color: palette.red },
    rulesGrid: { marginLeft: 35, width: '80%' },
    buttonConfirm: {
      height: 32,
      backgroundColor: palette.green,
      color: palette.white,
      marginRight: 8,
      '&:hover': {
        backgroundColor: palette.green,
      },
    },
    buttonConfirmDisabled: { backgroundColor: palette.greyCardBorder },
    buttonClean: { height: 32 },
    closeIconRule: { width: 15, height: 15, color: palette.red },
    doneIconRule: { width: 15, height: 15, color: palette.green },
    warnToMigrateTextError: {
      display: 'flex',
      color: palette.red,
      fontSize: 12,
      alignItems: 'center',
    },
    warnToMigrateTextDone: {
      display: 'flex',
      color: palette.green,
      fontSize: 12,
      alignItems: 'center',
    },
    ruleBoldGreen: {
      fontSize: 12,
      color: palette.green,
      fontWeight: 600,
      margin: '0px 2px',
    },
    ruleBoldRed: {
      fontSize: 12,
      color: palette.red,
      fontWeight: 600,
      margin: '0px 2px',
    },
    ruleBold: { fontSize: 12, fontWeight: 600, margin: '0px 4px' },
    switchText: {
      fontSize: 12,
      fontWeight: 500,
      color: state ? palette.darkGreen : palette.darkRed,
    },
    content: {
      padding: '10px 40px 16px 40px',
      boxSizing: 'border-box',
      '& .MuiTypography-body1': {
        fontSize: '12px !important',
        fontWeight: '500',
        alignItems: 'center',
        display: 'flex',
        marginRight: 8,
      },
      '& .MuiSvgIcon-root': {
        width: 15,
        height: 15,
      },
      '& .MuiInputLabel-outlined': {
        fontSize: 12,
      },
      '& .MuiFormControlLabel-root.Mui-disabled': { cursor: 'not-allowed' },
    },
    timeIcon: { color: palette.deepBlue, fontSize: 16 },
    textFieldLabel: {
      fontSize: 14,
      color: palette.darkGray,
      whiteSpace: 'nowrap',
    },
    textFieldLabelMinutes: {
      fontSize: 14,
      color: palette.darkGray,
      whiteSpace: 'nowrap',
      marginLeft: 8,
    },
    operatingInput: { display: 'flex', alignItems: 'center', margin: 4 },
    operatingGrid: { alignItems: 'center' },
    operatingTextField: {
      width: 60,
      '& .MuiOutlinedInput-root': { height: 32 },
    },
    detailsTextInstances: { marginLeft: 8 },
    detailsTextTable: { fontSize: 12 },
    filterSelector: {
      justifyContent: 'space-between',
      marginBottom: 16,
      display: 'flex',
      '& .MuiOutlinedInput-root': { width: '95%' },
    },
    applyButton: { borderColor: palette.blue, color: palette.blue },
    filterButtons: { display: 'flex' },
    pdfButtonGrid: { display: 'flex', alignItems: 'center' },
    alert: {
      maxWidth: 500,
      width: 'fit-content',
      margin: '0px auto 8px auto',
      fontSize: 12,

      '& b': {
        fontWeight: 900,
      },
    },
    toggles: { margin: 0 },
    textAlert: { fontSize: 12 },
    enabledZeroTrust: {
      width: 16,
      height: 16,
      marginRight: 10,
      color: palette.green,
    },
    failedZeroTrust: {
      width: 16,
      height: 16,
      marginRight: 10,
      color: palette.grey700,
    },
    disabledZeroTrust: {
      width: 16,
      height: 16,
      marginRight: 10,
      color: palette.grey400,
    },
    startingZeroTrust: {
      width: 16,
      height: 16,
      marginRight: 10,
      color: palette.yellow,
    },
    tooltip: {
      lineHeight: '0px !important',
      '& .MuiTooltip-tooltip': {
        lineHeight: '0px !important',
      },
    },
    summary: { flexFlow: 'row' },
  });

export const overrideTitleBehavior = {
  wrapper: {
    margin: '8px 0 24px',
  },
};

export const overrideSwitch = (state: boolean): any => ({
  switchContainer: {
    margin: '0px 0px 24px 8px',
    padding: 0,
    '& .MuiFormControlLabel-root': {
      marginRight: 0,
      paddingRight: 16,
      backgroundColor: state ? palette.superLightGreen : palette.superLightRed,
      borderRadius: 25,
    },
    '& .MuiSwitch-track': {
      backgroundColor: ` ${
        state ? palette.darkGreen : palette.darkRed
      } !important`,
      opacity: '0.4 !important',
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: state ? palette.darkGreen : palette.darkRed,
    },
  },
});

export const overrideToggleCard = {
  container: {
    width: '100%',
    boxShadow: '0 2px 4px 0 rgb(0 0 0 / 20%)',
    '& .MuiCardHeader-root': {
      padding: '6px 10px',
    },
  },
};
